module.exports = __webpack_public_path__ + "static/media/deine-buga__image--delete.957719bc.svg";